import { render } from "./VideoViewForIonSlides.vue?vue&type=template&id=24fba418&scoped=true&ts=true"
import script from "./VideoViewForIonSlides.vue?vue&type=script&lang=ts"
export * from "./VideoViewForIonSlides.vue?vue&type=script&lang=ts"

import "./VideoViewForIonSlides.vue?vue&type=style&index=0&id=24fba418&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fba418"]])

export default __exports__